import { Fade, IconButton } from '@material-ui/core'
import React, { useCallback, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import { StyledMenu } from './Navigation'
import StyledMenuLink from './StyledMenuLink'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import useStyles from './styles'

const NavMenuUserIcon = ({ logout }) => {
    const classes = useStyles()
    const [anchorEl, setAnchorEl] = useState(null)
    const open = !!anchorEl

    const handleClick = useCallback(event => {
        setAnchorEl(event.currentTarget)
    }, [])

    const handleClose = useCallback(() => {
        setAnchorEl(null)
    }, [])

    return (
        <div id="nav-user-icon">
            <IconButton
                edge="start"
                className={classes.menuButton}
                color="inherit"
                aria-label="menu"
                onClick={handleClick}
            >
                <FontAwesomeIcon icon={faUser} color="#ffffff" size="xs" />
            </IconButton>
            <StyledMenu
                id="fade-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                TransitionComponent={Fade}
            >
                <StyledMenuLink to="/account" text="My Account" mobile id="navbar-user-settings" />
                <StyledMenuLink to="/logout" text="Log out" onClick={logout} mobile id="navbar-sign-out" />
            </StyledMenu>
        </div>
    )
}

NavMenuUserIcon.propTypes = {
    logout: PropTypes.func.isRequired,
}

export default React.memo(NavMenuUserIcon)
